export default {
      id: "btn_minus-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite.svg#btn_minus",
      toString: function () {
        return this.url;
      }
    }